import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ReportRunnerService from '../../../Services/ReportRunnerSerivce';
import EvaluatorPaymentsExportSearchParams from './EvaluatorPaymentsExportSearchParams';

export default class EvaluatorPaymentsExportWindowDescription {
  static titleForCreate = 'Approved Evaluator Payments Export';
  static titleForEdit = 'Approved Evaluator Payments Export';
  static itemType = EvaluatorPaymentsExportSearchParams;
  static serviceFunction = ReportRunnerService.RequestEvaluatorPaymentsExportReport;
  static waitForServiceFunction = () => false;
  static finishButtonLabel = 'Export';
  static messageOnSuccess =
    'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'Report',
          label: 'Report',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EvaluatorPaymentsExportWindowDescription.GetReportTypes(),
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'SelectedThirdPartyEvaluatorIds',
          label: 'Selected Predefined Third-Party Evaluators',
          className: 'col-12',
          type: InputTypesEnum.PredefinedTpEvaluatorsMultiChoice,
          hide: (item) => item.Report !== '1',
          validityChecker: EvaluatorPaymentsExportWindowDescription.forRequiredEvaluatorId,
        },
        {
          fieldName: 'SelectedEvaluatorIds',
          label: 'Selected Predefined Evaluators',
          className: 'col-12',
          type: InputTypesEnum.PredefinedEvaluatorsMultiChoice,
          hide: (item) => item.Report !== '2',
          validityChecker: EvaluatorPaymentsExportWindowDescription.forRequiredEvaluatorId,
        },
        {
          fieldName: 'ThirdPartyEvaluatorIdsText',
          label: 'Third-Party Evaluator IDs (comma separated)',
          className: 'col-12',
          type: InputTypesEnum.TextArea,
          hide: (item) => item.Report !== '1',
          validityChecker: EvaluatorPaymentsExportWindowDescription.forRequiredEvaluatorId,
        },
        {
          fieldName: 'EvaluatorIdsText',
          label: 'Evaluator IDs (comma separated)',
          className: 'col-12',
          type: InputTypesEnum.TextArea,
          hide: (item) => item.Report !== '2',
          validityChecker: EvaluatorPaymentsExportWindowDescription.forRequiredEvaluatorId,
        },
      ],
    },
  ];

  static GetReportTypes() {
    return [
      { value: '', label: 'Choose one...' },
      { value: 1, label: 'Third-Party Evaluator' },
      { value: 2, label: 'Evaluator' },
    ];
  }

  static forRequiredEvaluatorId(e, item) {
    if (
      item.Report &&
      item.Report === '1' &&
      (!item.SelectedThirdPartyEvaluatorIds || item.SelectedThirdPartyEvaluatorIds.length === 0) &&
      (!item.ThirdPartyEvaluatorIdsText || item.ThirdPartyEvaluatorIdsText.trim() === '')
    ) {
      return 'At least one Third-Party Evaluator ID must be selected or entered.';
    } else if (
      item.Report &&
      item.Report === '2' &&
      (!item.SelectedEvaluatorIds || item.SelectedEvaluatorIds.length === 0) &&
      (!item.EvaluatorIdsText || item.EvaluatorIdsText.trim() === '')
    ) {
      return 'At least one Evaluator ID must be selected or entered.';
    }
    return '';
  }
}
